module.exports = __webpack_public_path__ + "img/banner-icon-3.b17f3184.webp";